import styled from 'styled-components';

import { FieldWrapperStyled } from '../../components/FormikInput/FormikInput.styled';
import Heading from '../../components/Heading/Heading.styled';
import { MainTitleStyled } from '../../components/Layout/PageLayout/PageLayout.styled';
import Paper from '../../components/Paper/Paper.styled';

export const PageTitleStyled = styled(MainTitleStyled)`
  margin-bottom: 25px;
`;

export const SectionWrapperStyled = styled(Paper)`
  padding: 45px 30px;
`;

export const SectionTitleStyled = styled(Heading)`
  text-transform: capitalize;
  margin-bottom: 20px;
`;

export const TopSectionStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const ControlsWrapperStyled = styled.div`
  margin-top: 40px;
  display: flex;
  gap: 50px;

  ${({ theme }) => `
    ${theme.devices.mobile} {
      gap: 20px;
    }
  `}
`;

export const FormRowStyled = styled.div`
  display: flex;
  gap: 25px;

  ${FieldWrapperStyled} {
    flex: 1;
  }

  & + & {
    margin-top: 20px;
  }

  ${({ theme }) => `
    ${theme.devices.mobile} {
      flex-direction: column;
    }
  `}
`;
